import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from '../src/routers/index.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueVideoPlayer from 'vue-video-player';

// 引入样式
import 'video.js/dist/video-js.css';
import 'vue-video-player/src/custom-theme.css';
import "videojs-flash";

import store from './store/store'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import DataView from '@jiaminghi/data-view'

Vue.use(DataView)

//引入echarts
import * as echarts from 'echarts'
//vue全局注入echarts
Vue.prototype.$echarts = echarts;


import VueBMap from 'vue-bmap-gl';
import 'vue-bmap-gl/dist/style.css'

Vue.use(VueBMap);
VueBMap.initBMapApiLoader({
  ak: 'xdbp1Y4aqtNfaltbd1OeKMMJ2srcCz18',
  // 默认百度 sdk 版本为 1.0
  v: '1.0',
  plugins: 'Lushu,TrackAnimation'
});








// 使用组件
Vue.use(VueVideoPlayer)


Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(VueRouter)

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')